/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'
import UiSelectWithGraphics, { UiSelectOption } from 'components/Ui/UiSelectWithGraphics'

interface UiFormSelectFieldProps {
    name: string
    label: string
    value: string | number | null | undefined
    options?: UiSelectOption[]
    groupedOptions?: { groupLabel: string; options: UiSelectOption[] }[]
    onChange: (value: string | number | null) => void
    className?: string
    labelClassName?: string
    isRequired?: boolean
    error?: string | null
    dropdownDirection?: 'up' | 'down'
}

const UiFormSelectField: React.FC<UiFormSelectFieldProps> = (props) => {
    const hasError = Boolean(props.error)

    return (
        <div className={clsx('UiFormSelectField flex flex-col', props.className)}>
            <UiSelectWithGraphics
                label={props.label}
                options={props.options}
                groupedOptions={props.groupedOptions}
                selected={props.value ?? null}
                setSelected={(value) => props.onChange(value)}
                dropdownDirection={props.dropdownDirection}
                disabled={
                    props.isRequired === true &&
                    ((Array.isArray(props.options) && props.options.length === 0) ||
                        (!props.options && (!props.groupedOptions || props.groupedOptions.length === 0)))
                }
            />
            {hasError && (
                <span className={clsx('mt-1 text-sm text-red-500')}>
                    {props.error}
                </span>
            )}
        </div>
    )}

export default UiFormSelectField
